<template>
    <div class="user-register2">
        <h4 style="text-align: center;margin-bottom: 30px">添加销售区域</h4>
        <a class="mint-cell mint-field">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text">代理区域</span>
                </div>
                <div class="mint-cell-value" style="background-color: rgb(235, 235, 228);line-height: 1.6;color: #888;cursor: pointer;" @click="select()">
                    <span v-for="item in userInfo.AreaList" :key="item.id" style="padding-right: 10px;">
                        <span style="padding-right: 5px;">{{item.AreaName}}</span>
                        <i @click.stop="deleteAddress(item)" class="fa fa-close"></i>
                    </span>
                    <span v-if="userInfo.AreaList.length == 0">点击选择代理区域</span>
                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a>
        <a class="mint-cell mint-field" style="margin-top: 10px;" v-if="isAddSchool">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text">代理学校</span>
                </div>
                <div class="mint-cell-value" style="background-color: rgb(235, 235, 228);line-height: 1.6;color: #888;cursor: pointer;" @click="selectSchool()">
                    <div v-for="item in userInfo.schoolList" :key="item.id" style="padding-right: 10px;">
                        <span style="padding-right: 5px;">{{item.Name}}</span>
                        <i @click.stop="deleteSchool(item)" class="fa fa-close"></i>
                    </div>
                    <span v-if="userInfo.schoolList.length == 0">点击选择代理学校</span>
                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a>
        <mt-switch style="margin-top: 10px" v-model="isAddSchool"><span v-if="!isAddSchool">不</span>选择代理学校</mt-switch>
        <yz-select v-if="show" :ref="show" @changeValue='isShow' :province='province' :city='city' :county='county'></yz-select>
        <select-school v-if="show_sch" :ref="show_sch" @changeValue='isShowSch' :areas='userInfo.AreaList'></select-school>
        <mt-button class="submit-btn" size="large" type="primary" @click.native="addAreasClick()">添加{{isAddSchool?'代理学校':'代理区域'}}</mt-button>
    </div>
</template>

<script>
import select from '@/components/select'
import selectSchool from '@/components/selectSchool'
export default {
  components:{
    'yz-select': select,
    'select-school': selectSchool
  },
  data() {
    return {
        codeValue: '获取验证码',
        validCode: true,
        show: false,
        show_sch: false,
        province: '',
        city: '',
        county: '',
        userInfo: {
            AreaList: [ ],
            schoolList: [ ]
        },
        isAddSchool: false
    }
  },
  methods: {
    select(){ this.show = true },
    selectSchool(){
        if(this.userInfo.AreaList.length>0) {
            this.show_sch = true;
        }else{
            this.abp.api.reqSuccess(this,'请先选择代理区域');
        }
    },
    isShow(msg){
        let _this = this;
        // console.log(msg);
        _this.show = msg.show;
        _this.address = msg.result;
        _this.province = msg.province;
        _this.city = msg.city;
        _this.county = msg.county;
        if(msg.lastcityobj) {
            let arr = _this.userInfo.AreaList;
            for (let index = 0; index < arr.length; index++) {
                if(arr[index].AreaID == msg.lastcityobj.id){
                    return;
                }
            }
            _this.userInfo.AreaList.push({
                AreaID: msg.lastcityobj.id,
                AreaName: _this.address,
                value: msg.lastcityobj.value
            })
        }
    },
    isShowSch(backdata){
        let _this = this;
        _this.show_sch = backdata.show;
        if(backdata.school) {
            let arr = _this.userInfo.schoolList;
            for (let index = 0; index < arr.length; index++) {
                if(arr[index].ID == backdata.school.ID){
                    return;
                }
            }
            _this.userInfo.schoolList.push({
                ID: backdata.school.ID,
                Name: backdata.school.FullName,
                value: backdata.school.FullName
            })
        }
    },
    getCode(){
        var time=60;
        var that = this;
        if(this.validCode){
            this.validCode = false;
            this.codeValue =  time + '秒';
            var t = setInterval(getTime,1000)
        }
        function getTime(){
            time--;
            that.codeValue =  time + '秒';
            if (time == 0) {
                clearInterval(t);
                that.codeValue = '重新获取';
                that.validCode=true;
            }
        }
    },
    // 删除代理区域
    deleteAddress(e) {
        let info = e,
            _this = this;
        _this.userInfo.AreaList.forEach((element,index) => {
            if(info.ID == element.ID){
                _this.userInfo.AreaList.splice(index,1)
            }
        });
    },
    // 删除学校
    deleteSchool(e) {
        let info = e,
            _this = this;
        _this.userInfo.schoolList.forEach((element,index) => {
            if(info.ID == element.ID){
                _this.userInfo.schoolList.splice(index,1)
            }
        });
    },
    addAreasClick() {
        let _this = this,
            userInfo = {};
        if(!_this.isAddSchool&&_this.userInfo.AreaList.length == 0) {
            _this.abp.api.reqSuccess(_this,'代理区域不能为空');
            return;
        }
        if(_this.isAddSchool&&_this.userInfo.schoolList.length == 0) {
            _this.abp.api.reqSuccess(_this,'代理学校不能为空');
            return;
        }
        userInfo = {
            AreaList: !_this.isAddSchool?_this.userInfo.AreaList:'',
            SchoolList: _this.isAddSchool?_this.userInfo.schoolList:''
        }
        _this.$indicator.open('加载中...');
        _this.abp.api.AgentBindInfo(userInfo)
            .then((res)=> {
                if(res.status == 200) {
                    if(res.data.IsSuccess) {
                        _this.$indicator.close();
                        _this.abp.UserInfos.userIsBind = true;
                        sessionStorage.setItem('userIsBind',true);
                        _this.$router.replace(this.$route.query.redirect || '/home' );
                    }else{
                        _this.$indicator.close();
                        _this.abp.api.reqSuccess(_this,res.data.OutputMessage);
                    }
                }else {
                    _this.$indicator.close();
                }
            })
            .catch((error)=> {
                let _this = this;
                _this.$indicator.close();
                _this.abp.api.reqSuccess(this,error?_this.res.data.OutputMessage:'登录出错!')
            })
    }
  },
  mounted() {
    var clientHeight = document.body.clientHeight;
    var _focusElem = null;
    document.body.addEventListener("focus", function(e) {
        _focusElem = e.target || e.srcElement;
    }, true);
    window.addEventListener("resize", function() {
        if(_focusElem && document.body.clientHeight < clientHeight) {
            _focusElem.scrollIntoView(true);
        }
    });
  }
}
</script>

<style>
    .user-register2 {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .user-register2 .submit-btn {
        width: 80%;
        margin: auto;
        margin-top: 50px;
    }
    .user-register2 .mint-field .mint-cell-value {
        display: block;
    }
    .user-register2 .mint-switch {
        justify-content: flex-end;
        padding-right: 10px;
    }
    .user-register2 .mint-switch-core {
        height: 27px;
    }
    .user-register2 .mint-switch-core:after,
    .user-register2 .mint-switch-core:before {
        height: 25px;
    }
</style>
